import { Dispatch } from 'react';
import { get, post, put, remove } from 'communication/httpClient';
import {
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  TOUCHPOINTS_RESET,
  TOUCHPOINTS_SET,
  TOUCHPOINT_GROUPS_SET,
  TOUCHPOINT_REMOVE,
  TOUCHPOINT_SET,
  TOUCHPOINT_TYPES_SET,
} from './actionTypes';
import { ITouchpoint, ITouchpointsAction, ITouchpointsActions } from './types';

export const getActions = (dispatch: Dispatch<ITouchpointsAction>): ITouchpointsActions => ({
  deleteTouchpoint: async (id: string, params, callback?: () => void) => {
    dispatch({
      type: SYNC_INITIATED,
      payload: { id },
    });
    const { error } = await remove(`/api/touchpoints/${id}`, { params });

    // checking for error because no response is sent for successful action
    if (!error) {
      dispatch({
        type: TOUCHPOINT_REMOVE,
        payload: { id },
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadTouchpoint: async (id: string, params) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get(`/api/touchpoints/${id}`, { params });

    if (data) {
      dispatch({
        type: TOUCHPOINT_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadTouchpointGroups: async () => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get('/api/touchpoint-groups');

    if (data) {
      dispatch({
        type: TOUCHPOINT_GROUPS_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadTouchpoints: async (params) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get('/api/touchpoints', { params });

    if (data) {
      dispatch({
        type: TOUCHPOINTS_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  loadTouchpointTypes: async () => {
    dispatch({
      type: SYNC_INITIATED,
    });
    const { data, error } = await get('/api/touchpoint-applications');

    if (data) {
      dispatch({
        type: TOUCHPOINT_TYPES_SET,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
  resetTouchpoints: () => {
    dispatch({
      type: TOUCHPOINTS_RESET,
    });
  },
  saveTouchpoint: async (touchpoint: ITouchpoint, isNew: boolean, callback?: () => void) => {
    dispatch({
      type: SYNC_INITIATED,
    });
    touchpoint.deviceIds = touchpoint.deviceIds || [];
    const handler = !isNew ? put : post;
    const url = !isNew ? `/api/touchpoints/${touchpoint.id}` : '/api/touchpoints';
    const { data, error, success } = await handler(url, touchpoint);

    if (success && callback) {
      callback();
    }
    if (data) {
      dispatch({
        type: TOUCHPOINT_SET,
        payload: touchpoint,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
    dispatch({
      type: SYNC_FINISHED,
    });
  },
});
